import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {FormButtonsComponent} from "../form-buttons/form-buttons.component";
import {PaymentService} from "../../services/payment/payment.service";
import {finalize} from "rxjs";
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
  selector: 'homey-resubscribe-dialog',
  imports: [
    FormButtonsComponent
  ],
  templateUrl: './resubscribe-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResubscribeDialogComponent {
  private readonly paymentService = inject(PaymentService);
  private readonly dialogRef = inject(DynamicDialogRef);

  protected readonly options = computed(() => [
    {label: `Monthly - $${this.paymentService.monthlyPriceValue()}`, value: 'monthly' as const, severity: "secondary" as const},
  ]);

  protected readonly submitFunction = (_value: 'monthly') => {
    return this.paymentService.startPayment(
      false,
      "resubscribe"
    ).pipe(
      finalize(() => this.dialogRef.close())
    )
  }
}
